import { StatusHint, TextLink, Textarea } from '@indipia/ui-core';
import type { CustReqItem } from '@indipia/shared-features';
import { CustReqDeliveryCard, type CustReqLoadStatus } from './CustReqDeliveryCard';
import {
  CUST_REQ_ORDER_MESSAGE as M,
  canReloadMemo,
  memoHintKind,
  memoHintText,
} from '../../utils/custReqOrder.logic';

/**
 * 일괄 작업요청 공종 행의 [내용 ▸] 카드(941 S16-8) — 이 공종의 작업 요청내용(작업 요청 메모가 기본값)과 고객 요청 체크 목록.
 * 공통 덧붙임은 페이지 하단 입력란에서 받고, 서버가 이 공종 본문 뒤에 이어 붙인다.
 */
interface Props {
  body: string;
  onBodyChange: (value: string) => void;
  /** 이 공종의 작업 요청 메모(없으면 null) */
  memo: string | null;
  items: CustReqItem[];
  excluded: ReadonlySet<number>;
  onToggleReq: (custReqId: number) => void;
  reqStatus: CustReqLoadStatus;
  onRetryReq: () => void;
}

export function BulkTaskContentCard({ body, onBodyChange, memo, items, excluded, onToggleReq, reqStatus, onRetryReq }: Props) {
  const kind = memoHintKind(true, memo, body);
  return (
    <div className="mt-03 flex flex-col gap-03 rounded-lg border border-border bg-surface p-04">
      <div className="flex flex-wrap items-center gap-sm">
        <span className="text-body-sm font-bold text-text">{M.bulkBodyLabel}</span>
        <StatusHint tone="muted">{memoHintText(kind)}</StatusHint>
        {canReloadMemo(memo, body) && (
          <TextLink onClick={() => onBodyChange(memo ?? '')}>{M.memoReload}</TextLink>
        )}
      </div>
      <Textarea
        fill
        textareaClassName="min-h-11 resize-none"
        value={body}
        onChange={(e) => onBodyChange(e.target.value)}
        placeholder={M.bulkBodyPlaceholder}
        aria-label={M.bulkBodyLabel}
      />
      <CustReqDeliveryCard items={items} excluded={excluded} onToggle={onToggleReq} status={reqStatus} onRetry={onRetryReq} />
    </div>
  );
}
